// extracted by mini-css-extract-plugin
module.exports = {"IRAHeader":"IRAHeader_IRAHeader__NUd0r"};